import { render, staticRenderFns } from "./NotStarted.vue?vue&type=template&id=349d9ce0&scoped=true&"
import script from "./NotStarted.vue?vue&type=script&lang=js&"
export * from "./NotStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d9ce0",
  null
  
)

export default component.exports